import { FC, useEffect, useState } from 'react'
import RequiredEmailConfirmationModal from './components/RequiredEmailConfirmationModal/RequiredEmailConfirmationModal'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'

interface IRequiredEmailConfirmation {}

const RequiredEmailConfirmation: FC = () => {
  const [verifyEmail, setVerifyEmail] = useState(false)

  const { profile, settings } = useSelector((store: any) => ({
    profile: selectProfile(store),
    settings: store.settings,
  }))

  useEffect(() => {
    if (!profile || profile.is_email_confirmed === 1 || profile?.is_email_confirmed === undefined) return

    const { role } = profile
    const {
      requireParentEmailConfirmation,
      requireStudentEmailConfirmation,
      requireEmployeeEmailConfirmation,
    } = settings

    const needsVerification =
      (role === 'children' && requireStudentEmailConfirmation === '1') ||
      (role === 'parent' && requireParentEmailConfirmation === '1') ||
      (!['children', 'parent'].includes(role) &&
        requireEmployeeEmailConfirmation === '1')

    setVerifyEmail(needsVerification)
  }, [profile, settings, profile?.is_email_confirmed])

  return (
    <RequiredEmailConfirmationModal
      open={verifyEmail}
      onSuccess={() => setVerifyEmail(false)}
    />
  )
}

export default RequiredEmailConfirmation
